import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProjectService } from '../services/project.service';
import { ProjectTemperatureData } from '../models/project-temperature-data';

@Component({
  selector: 'app-project-information',
  templateUrl: './project-information.component.html',
  styleUrls: ['./project-information.component.scss'],
})
export class ProjectInformationComponent implements OnInit, OnDestroy {
  projectName: string = '';
  firstMeasurement: Date = new Date(0, 0, 0);
  lastMeasurement: Date = new Date(0, 0, 0);
  tempDataSubscription: Subscription = {} as Subscription;
  selectedProjectSubscription: Subscription = {} as Subscription;
  tempData: ProjectTemperatureData = {} as ProjectTemperatureData;
  currentTab: number = 1;

  constructor(public projectService: ProjectService) {}

  ngOnInit(): void {
    this.projectService.isHelpOverlayVisible = false;

    console.log('Metric:' + this.projectService.isMetricUnit);

    this.selectedProjectSubscription =
      this.projectService.selectedProject.subscribe(
        (data) => {
          this.projectName = data;
        },
        (error) => console.log(error)
      );

    this.tempDataSubscription = this.projectService.temperatureData.subscribe(
      (data) => {
        if (data == null) {
          console.log('Error in Temp Comp: Temp data is null.');
          return;
        } else if (data.TRC == null) {
          console.log('Error in Temp Comp: Temp data > TRC is null.');
          return;
        }

        this.tempData = data;
        if (this.tempData) {
          if (this.tempData.TRC.length > 0) {
            this.firstMeasurement = this.tempData.TRC[0].T;
            this.lastMeasurement =
              this.tempData.TRC[this.tempData.TRC.length - 1].T;
          }
        }
        //this.tempData.MI
      },
      (error) => console.log(error)
    );
  }

  ngOnDestroy(): void {
    this.selectedProjectSubscription.unsubscribe();
    this.tempDataSubscription.unsubscribe();
  }

  selectTab(tabNo: number) {
    this.currentTab = tabNo;
  }
}
